import { chatttSDKChannel } from '../sdk';

const isChannel = (targetHash: string | string[]) =>
  !!chatttSDKChannel &&
  ([] as string[]).concat(targetHash).some((t) => t === (chatttSDKChannel as any));

export default isChannel;
